
import { builderDispatch, WebUI } from '../../_utils/ui';

let notifyTimeout;

const service = function (service) {
  if (typeof builderDispatch === 'undefined') {
    return;
  } // sanity check !

  builderDispatch.dispatch({
    type: WebUI.PHOTO_SERVICE_SELECTED,
    service
  });
};

const clickEvent = function (event) {
  if (typeof builderDispatch === 'undefined') {
    return;
  } // sanity check !

  clearTimeout(notifyTimeout);

  notifyTimeout = setTimeout(() => {
    builderDispatch.dispatch({
      type: WebUI.PHOTO_EVENT_UPLOAD,
      uploadEvent: event
    });
  }, 100);
};

export default {
  service,
  clickEvent,
};
